import React from 'react';
import { AgCharts } from 'ag-charts-react';
import type { AgChartProps } from 'ag-charts-react';
import { ModuleRegistry, AllCommunityModule } from 'ag-charts-community';
import type { AgChartOptions } from 'ag-charts-community';

// Register AG-Charts modules once
ModuleRegistry.registerModules([AllCommunityModule]);

/** Thin wrapper that ensures AG Charts is imported through a single point. */
const AgChartsWrapper: React.FC<AgChartProps> = (props) => {
  return (
    <div style={{ width: '100%', height: '100%', minHeight: 0 }}>
      <AgCharts
        {...props}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
};

export default AgChartsWrapper;
export type { AgChartOptions };
